export * from '@fhs/routing/src/routes/v2/offers/index';
export { default } from '@fhs/routing/src/routes/v2/offers/index';
